import type { Language } from "@app/constants";

interface Messages {
	instructionReceived: string;
	processedStandard: string;
	processedSTP: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		instructionReceived: "Withdraw instruction received",
		processedStandard: "This will be processed in the next 3 business days",
		processedSTP: "This will be processed in the next 1-2 business days",
	},
};

export default messages;
